<template>
    <ProfileModal ref="profileModal"/>
    <OrganizationModal ref="organizationModalRef" :modalId="'navbarOrganizationModal'" v-if="currentRoute != 'organizations'"/>

    <div v-if="screensLoaded" class="lativoNavbar">
        <header>
            <button class="hamburgerButton">
                <i :class="'bi bi-list'" data-bs-toggle="offcanvas" href="#offcanvasExample" role="button" aria-controls="offcanvasExample"></i>
            </button>

            <img class="logo" src="../../images/LativoLogoWhite.png" @click="GoToHome"/>

            <div v-for="(screen, index) in screens" :key="screen.PKScreen">
                <button v-if="screen.Children.length == 0" class="navbar-item navbar-item-desktop" @click="Redirect(screen.Route, index)"
                    @mouseover="setHovered(index)"
                    @mouseout="setHovered(null)">
                    {{ screen.DisplayName }}
                    <div :class="store.currentPanel != screen.Route && hoveredIndex === index ? 'hovered' : 'notHovered'">
                    </div>
                </button>

                <div v-else class="navbarDropdown"
                    @mouseenter="setDropdownHovered(index)"
                    @mouseleave="clearDropdownHovered(index, $event)">
                    <button
                        class="navbar-item navbar-item-desktop"
                        type="button"
                        data-mdb-toggle="dropdown"
                        aria-expanded="false">
                        {{ screen.DisplayName }}
                    </button>

                    <ul v-show="hoveredIndex === index"
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton">

                        <li v-for="(child) in screen.Children" :key="child.PKScreen">
                            <a class="dropdown-item" @click="Redirect(child.Route, index)">{{ child.DisplayName }}</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="navbar__actions">
                <div v-if="assistantEnabled && store.Actions.USE_ASSISTANT" class="dropdown assistant">
                    <button class="userButton assistantButton" @click="ToggleAiAssistant(true)">
                        <img src="../../images/BotIcon.png" height="18" width="18"/>
                    </button>
                </div>
                <NotificationsMenu/>
                <ProfileMenu/>
            </div>

        </header>

        <div class="offcanvas offcanvas-start lativoOffcanva" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">

            <div class="returnButton" data-bs-dismiss="offcanvas" aria-label="Close" ref="btnCloseOffcanva">
                <i class="bi bi-arrow-left"></i>
            </div>

            <div class="offcanvas-body">
                <div class="lativoOffcanva__itemList">

                    <div v-for="screen in screens" :key="screen.PKScreen" class="navbarItemWrapper">
                        <button v-if="screen.Children.length == 0" class="navbar-item mobile" @click="Redirect(screen.Route)">
                            {{ screen.DisplayName }}
                        </button>

                        <div v-else class="childNavbarItemWrapper">
                            <button class="navbar-item mobile childNavbarItem"
                                @click="screen.showChilds ? screen.showChilds = false : screen.showChilds = true" >
                                <label>{{ screen.DisplayName }}</label>

                                <i :class="screen.showChilds ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                            </button>

                            <div class="childsWrapper" :class="{ shown: screen.showChilds == true }">
                                <button v-for="(child) in screen.Children" :key="child.name" class="navbar-item mobile" @click="Redirect(child.Route, index)">
                                    {{ child.DisplayName }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="assistantWrapper">
        <vue-draggable-resizable
            v-if="assistantEnabled && store.Actions.USE_ASSISTANT"
            :key="assistantKey"
            ref="aiAssistant"
            :parent="!store.isMobile"
            :drag-handle="'.header'"
            :z="999"
            :x="x"
            :y="y"
            :min-width="300"
            :min-height="300"
            :w="width"
            :h="height"
            :active="true"
            :hidden="!showAiAssistant"
        >
            <AiAssistant/>
        </vue-draggable-resizable>
    </div>
</template>

<script>
import { useStore } from '@/store/DefaultStore.js';
import { useRouter } from 'vue-router';
import NotificationsMenu from './NotificationsMenu.vue';
import { getAuth } from 'firebase/auth';
import { useToast } from 'vue-toastification';
import ProfileMenu from '../Profile/ProfileMenu.vue';
import ProfileModal from '../Profile/ProfileModal.vue';
import OrganizationModal from '@/components/Views/Organizations/OrganizationModal.vue';
import vueDraggableResizable from 'vue-draggable-resizable';
import AiAssistant from '@/components/AI-Assistant/AiAssistant.vue';
import EventBus from '@/utilities/EventBus';
import { useSessionStore } from '@/store/SessionStore';

export default{
    name: 'NavBar',
    components: {
        NotificationsMenu, ProfileMenu, ProfileModal, OrganizationModal, vueDraggableResizable, AiAssistant
    },

    setup(){
        const store = useStore();
        const router = useRouter();
        const auth = getAuth();
        const toast = useToast();
        const sessionStore = useSessionStore();

        return{
            store, router, auth, toast, sessionStore
        }
    },

    data(){
        return {
            screens: [],
            screensLoaded: false,
            assistantEnabled: false,
            hoveredIndex: null,
            currentRoute: '',
            aiAssistantObserver: null,
            showAiAssistant: false,
            assistantKey: 0,
            x: 0,
            y: 0,
            width: 300,
            height: 300,
            dropdownCloseTimeout: null,
            safeTriangleMoveHandler: null
        }
    },

    watch: {
        $route(to){
            this.currentRoute = to.name;
        }
    },

    beforeMount() {
        this.ResetAssistant();
    },

    mounted(){
        EventBus.$on('AssistantEnabledSettingUpdated', this.GetAssistantIsEnabled);
        EventBus.$on('RedirectToLogin', this.RedirectToLogin);
        EventBus.$on('SetScreens', this.SetScreens);
    },

    beforeUnmount(){
        EventBus.$off('AssistantEnabledSettingUpdated', this.GetAssistantIsEnabled);
        EventBus.$off('RedirectToLogin', this.RedirectToLogin);
        EventBus.$off('SetScreens', this.SetScreens);

        this.cancelSafeTriangle();
    },

    methods:{
        async RedirectToLogin() {
            this.store.LoggedUser = null;
            this.router.push({ name: 'login' });
        },

        SetScreens(screens) {
            this.screens = screens;
            this.screensLoaded = true;
        },

        GetAssistantIsEnabled(AssistantEnabled) {
            this.assistantEnabled = AssistantEnabled;
        },

        ResetAssistant(){
            this.width = this.store.isMobile ? 300 : 400;
            this.height = this.store.isMobile ? 400 : 600;
            this.x = this.store.isMobile ? 0 : 25;
            this.y = this.store.isMobile ? 0 : 25;
            this.assistantKey++;
        },

        ToggleAiAssistant(value = !this.showAiAssistant){
            this.showAiAssistant = value;
            this.defaultWidth = 600;
        },

        GoToHome(){
            if(this.store.isCustomer)
                this.router.push({ name: 'files' })
            else
                this.router.push({ name: 'home' });
        },

        UpdateOrganization()
        {
            this.$refs.organizationModalRef.OpenModal(this.store.CurrentOrganizationPK, true);
        },

        OpenProfileModal(){
            this.$refs.profileModal.OpenModal();
        },

        LogoClickHandler(){
            if(this.store.isCustomer)
                this.router.push({ name: 'files' })
            else
                this.router.push({ name: 'home' });
        },

        Redirect(route, index){
            this.store.currentPanel = index
            this.router.push({ name: route });

            if(this.$refs.btnCloseOffcanva){
                this.$refs.btnCloseOffcanva.click();
            }

            this.setHovered(null);
        },

        setHovered(index) {
            this.hoveredIndex = index;
        },

        setDropdownHovered(index) {
            this.cancelSafeTriangle();
            this.hoveredIndex = index;
        },

        clearDropdownHovered(index, event) {
            this.cancelSafeTriangle();

            const wrapper = event && event.currentTarget;
            const menu = wrapper && wrapper.querySelector('.dropdown-menu');

            if (!menu || menu.offsetParent === null) {
                this.hoveredIndex = null;
                return;
            }

            const menuRect = menu.getBoundingClientRect();
            const apex = { x: event.clientX, y: event.clientY };
            const base1 = { x: menuRect.left, y: menuRect.top };
            const base2 = { x: menuRect.right, y: menuRect.top };

            this.safeTriangleMoveHandler = (e) => {
                const p = { x: e.clientX, y: e.clientY };
                if (this.pointInTriangle(p, apex, base1, base2)) return;
                this.cancelSafeTriangle();
                if (this.hoveredIndex === index) this.hoveredIndex = null;
            };
            document.addEventListener('mousemove', this.safeTriangleMoveHandler);

            this.dropdownCloseTimeout = setTimeout(() => {
                this.cancelSafeTriangle();
                if (this.hoveredIndex === index) this.hoveredIndex = null;
            }, 500);
        },

        cancelSafeTriangle() {
            if (this.dropdownCloseTimeout) {
                clearTimeout(this.dropdownCloseTimeout);
                this.dropdownCloseTimeout = null;
            }
            if (this.safeTriangleMoveHandler) {
                document.removeEventListener('mousemove', this.safeTriangleMoveHandler);
                this.safeTriangleMoveHandler = null;
            }
        },

        pointInTriangle(p, a, b, c) {
            const sign = (p1, p2, p3) =>
                (p1.x - p3.x) * (p2.y - p3.y) - (p2.x - p3.x) * (p1.y - p3.y);
            const d1 = sign(p, a, b);
            const d2 = sign(p, b, c);
            const d3 = sign(p, c, a);
            const hasNeg = d1 < 0 || d2 < 0 || d3 < 0;
            const hasPos = d1 > 0 || d2 > 0 || d3 > 0;
            return !(hasNeg && hasPos);
        },
    }
}
</script>

<style>
/* Desktop */
@media (min-width: 1200px){
    .hamburgerButton {
        display: none;
    }

    .logo {
        margin-left: 20px;
    }

    /* TODO: verify usage — .logo img targets no element in this template (.logo is the img itself) */
    .logo img {
        max-width: 140px;
        height: 20px;
    }

    .navbar-item.mobile {
        display: none;
    }

    .userButton img {
        margin-right: 5px;
    }

    .navbar-item-desktop {
        margin-left: 30px;
    }

    .userButton {
        margin-right: 15px;
    }
}

/* Compact desktop */
@media (min-width: 915px) and (max-width: 1200px){
    .navbar-item-desktop {
        margin-left: 5px;
    }

    .hamburgerButton {
        display: none;
    }

    .logo {
        margin-left: 20px;
    }
}

/* Mobile */
@media (max-width: 915px){
    .logo {
        top: 50%; transform: translate(60px, 0); margin: 0px; width: auto;
    }

    .navbar-item-desktop {
        display: none;
    }

    .childNavbarItemWrapper {
        display: flex;
        width: 100%;
        padding-left: 0px;
        padding-right: 0px;
        touch-action: manipulation;
    }

    .childNavbarItemWrapper button {
        width: 100%;
    }

    .childNavbarItem {
        padding-left: 10px !important;
    }

    .childNavbarItem i {
        margin-left: 10px;
    }

    .navbarItemWrapper {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }

    .userButton {
        margin-right: 10px;
    }
}

.navbar__actions {
    margin-left: auto;
    display: flex;
    align-items: center;
}

.assistantWrapper {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 999 !important;
    width: 100%;
    height: 100vh;
    pointer-events: none;
}

.lativoOffcanva .offcanvas-body div {
    display: flex;
    flex-direction: column;
    padding: 20px;
    font-size: 20px;
}

.lativoOffcanva .lativoOffcanva__itemList {
    padding-top: 0;
}

.childsWrapper {
    display: none !important;
}

.childsWrapper.shown {
    display: flex !important;
}

.navbarDropdown:hover>.dropdown-menu {
    display: block;
    margin-left: 25px;
    background-color: var(--LativoDarkPurple);
    box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2);
    cursor: pointer;
}

.dropdown-item {
    height: 36px;
    display: flex;
    align-items: center;
}

.dropdown-item:hover {
    background-color: var(--LativoDarkPurple);
}

.dropdown-menu > li > a:hover {
    color: lightgray;
}

.dropdown-menu > li > a {
    color: white;
    font-size: 15px;
}

.navbarDropdown>.dropdown-toggle:active {
    pointer-events: none;
}

.lativoNavbar {
    position: sticky;
    top: 0px;
    z-index: 996 !important;
}

.lativoNavbar header {
    background-color: var(--LativoDarkPurple);
    color: white;
    width: 100%;
    height: 60px;
    display: flex;
    position: sticky;
    top: 0px;
    align-items: center;
}

/* TODO: verify usage — .logo img targets no element in this template (.logo is the img itself) */
.logo img {
    max-width: 140px;
    margin: 0px;
}

.logo {
    height: 20px;
    cursor: pointer;
    padding: 0px;
}

.hamburgerButton {
    background-color: transparent;
    border: none;
    position: absolute;
    left: 0px;
    margin-left: 10px;
}

.hamburgerButton i {
    color: rgb(245, 245, 245);
    font-size: 30px !important;
}

.lativoOffcanva {
    background-color: transparent;
    border: none !important;
    width: 100% !important;
}

.lativoOffcanva .returnButton {
    color: white;
    position: absolute !important;
    top: 15px !important;
    left: 25px !important;
    background-color: none;
    padding-top: 0px;
    cursor: pointer;
}

.lativoOffcanva .returnButton i {
    font-size: 24px;
    margin-right: 5px;
}

.lativoOffcanva .offcanvas-body {
    background-color: rgb(31, 31, 44, 0.9);
    color: white;
}

.lativoOffcanva div {
    padding-top: 80px;
}

.navbar-item {
    background-color: transparent;
    font-size: 14px;
    height: 60px;
    border-radius: 10px;
    border: none;
    color: white;
    cursor: pointer;
}

.navbar-item div {
    display: block;
    height: 1px;
    background-color: white;
}

.navbar-item.mobile {
    /* TODO: verify !important — possible conflict with external styles */
    margin-left: 0px !important;
    font-size: 18px !important;
    margin-bottom: 30px !important;
}

.userButton {
    background-color: transparent;
    border: none;
    color: white;
    font-size: 14px;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 15px;
    position: relative;
    margin-left: auto;
    height: 40px;
}

/* TODO: verify usage — not referenced in this template; may be used by child components */
.userButton.mobile {
    border-radius: 50%;
    width: 40px;
}

.userButton:hover {
    background-color: rgb(40, 40, 40);
}

.userButton img {
    height: 30px;
    width: 30px;
    border-radius: 50%;
}

.userButton.assistantButton img {
    height: 18px;
    width: 18px;
    border-radius: 0;
    margin-right: 0px;
}

.userButton i {
    font-size: 18px;
}

.userButton.mobile i {
    /* TODO: verify !important — possible conflict with external styles */
    margin-right: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.userButtonMenu {
    cursor: pointer;
    background-color: var(--LativoDarkPurple);
    color: white;
    padding-left: 15px;
    padding-right: 15px;
    box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.2);
}

.userButtonMenu:hover {
    background-color: rgb(62, 62, 62);
}

.hovered {
    animation: startHover 0.3s forwards;
}

.notHovered {
    animation: endHover 0.3s forwards;
}

@keyframes startHover {
    from {
        opacity: 0;
        width: 0;
    }
    to {
        opacity: 1;
        width: 100%;
    }
}

@keyframes endHover {
    from {
        opacity: 1;
        width: 100%;
    }
    to {
        opacity: 0;
        width: 0;
    }
}
</style>
